import axios from 'axios';

const RESSOURCE_NAME = 'supplier_quality';

export default {

    getSupplierQualities(query = "", page = 0, column = 'date', order = 'DESC') {
        return axios.get(`${RESSOURCE_NAME}/search?page=${page}&size=${process.env.VUE_APP_NB_DISPLAY}&orderBy=${column}&sortBy=${order}&query=${encodeURIComponent(query)}`)
    },

    getSupplierQuality(id) {
        return axios.get(`${RESSOURCE_NAME}/${id}`)
    },

    createSupplierQuality(supplierQuality) {
        return axios.post(`${RESSOURCE_NAME}/add`, { supplierQuality })
    },

    updateSupplierQuality(id, supplierQuality) {
        return axios.patch(`${RESSOURCE_NAME}/${id}`, { supplierQuality })
    },

    deleteSupplierQuality(id) {
        return axios.delete(`${RESSOURCE_NAME}/delete/${id}`)
    },

    toggleAcceptance(id, isAccepted) {
        return axios.post(`${RESSOURCE_NAME}/${id}/acceptance`, { isAccepted })
    },

    toggleReturn(id, needReturn) {
        return axios.post(`${RESSOURCE_NAME}/${id}/return`, { needReturn })
    },

    toggleDeliveryFta(id, isDeliveryFta) {
        return axios.post(`${RESSOURCE_NAME}/${id}/delivery`, { isDeliveryFta })
    },

    updateStatus(id, status) {
        return axios.post(`${RESSOURCE_NAME}/${id}/status`, { status })
    },

    getYearCount(year) {
        return axios.get(`${RESSOURCE_NAME}/count/year/${year}`)
    },

    getUnclosedCount() {
        return axios.get(`${RESSOURCE_NAME}/count/unclosed`)
    }
}
